import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoHide: { type: Boolean, default: true },
    autoHideDelay: { type: Number, default: 8000 }
  }

  connect() {
    if (this.autoHideValue) {
      this.hideTimeout = setTimeout(() => {
        this.close()
      }, this.autoHideDelayValue)
    }
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
  }

  close() {
    this.element.classList.add('opacity-0')
    setTimeout(() => {
      this.element.remove()
    }, 300) // Wait for transition to complete
  }

  // Static method to show notifications programmatically
  static show(message, type = 'success') {
    const notification = document.createElement('div')
    let bgClass = "bg-gray-500"
    switch (type) {
      case 'success':
        bgClass = "bg-green-500"
        break
      case 'info':
        bgClass = "bg-blue-500"
        break
      case 'error':
        bgClass = "bg-red-500"
        break
    }
    notification.setAttribute('data-controller', 'notification')
    notification.setAttribute('data-notification-auto-hide-value', 'true')
    notification.setAttribute('data-notification-auto-hide-delay-value', '8000')
    notification.className = `notification-container notification-${type} fixed right-4 px-6 py-3 rounded-md shadow-md ${bgClass} text-white transition-opacity duration-300 z-50`

    // Calculate position based on existing notifications
    const existingNotifications = document.querySelectorAll('.notification-container')
    const bottomSpacing = 16 // 4rem in pixels
    const notificationHeight = 48 // Approximate height of notification in pixels
    const spacing = 8 // Space between notifications in pixels

    const bottomPosition = bottomSpacing + (existingNotifications.length * (notificationHeight + spacing))
    notification.style.bottom = `${bottomPosition}px`

    // Create content with close button
    const content = document.createElement('div')
    content.className = 'flex items-center justify-between'

    const messageEl = document.createElement('span')
    messageEl.textContent = message
    content.appendChild(messageEl)

    const closeButton = document.createElement('button')
    closeButton.innerHTML = '&times;'
    closeButton.className = 'ml-3 text-white hover:text-gray-200'
    closeButton.setAttribute('data-action', 'notification#close')
    content.appendChild(closeButton)

    notification.appendChild(content)
    document.body.appendChild(notification)

    return notification
  }
}
